export const replaceInstallationName = (text, installationName) => {
  if (!text || !installationName) return text;

  // Keep URLs, emails, package names and SDK identifiers intact.
  return text.replace(
    /(https?:\/\/[^\s"'<>]+|[\w.+-]+@[\w.-]+|[@$][\w./:-]+|[\w$]+(?:[.:/][\w$-]+)+)|\bchatwoot\b/gi,
    match => (/^chatwoot$/i.test(match) ? installationName : match)
  );
};

export const brandMessages = (messages, installationName) => {
  if (!installationName || installationName === 'Chatwoot') return messages;
  if (typeof messages === 'string') {
    return replaceInstallationName(messages, installationName);
  }
  if (typeof messages !== 'object' || messages === null) return messages;
  if (Array.isArray(messages)) {
    return messages.map(value => brandMessages(value, installationName));
  }
  return Object.fromEntries(
    Object.entries(messages).map(([key, value]) => [
      key,
      brandMessages(value, installationName),
    ])
  );
};
